export const KYC_PROVIDER = {
  SHUFTI_PRO: 'ShuftiPro',
  manual: 'Manual'
};
